<script>
import { VDivider } from 'vuetify/lib';
export default VDivider;
</script>
